import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ServicesBento from "@/components/ServicesBento";
import PricingPackages from "@/components/PricingPackages";
import Gallery from "@/components/Gallery";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function Home() {
  const [settings, setSettings] = useState(null);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings(r.data))
      .catch(() => setSettings({}));
    api
      .get("/gallery")
      .then((r) => setGallery(r.data || []))
      .catch(() => setGallery([]));
  }, []);

  useEffect(() => {
    if (!settings) return;
    document.title = `${settings.business_name || "MSJ Car Detailing"} | ${settings.tagline || "San Diego"}`;
  }, [settings]);

  return (
    <div className="bg-[#050505] min-h-screen text-white">
      <Navbar settings={settings} />
      <main>
        <Hero settings={settings} />
        <ServicesBento />
        <PricingPackages />
        <Gallery images={gallery} />
        <ContactForm settings={settings} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
